import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { AsyncComponentErrorHandler } from 'crm-events-components/internal/helpers/AsyncComponentErrorHandler';
import CompactSingleLineSkeleton from 'crm-events-components/internal/skeletons/CompactSingleLineSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
const CompactCreateSourceEventAsync = Loadable({
  loader: () => import( /* webpackChunkName: "compact-card-CompactCreateSourceEvent" */'./CompactCreateSourceEvent').then(mod => mod.default),
  LoadingComponent: () => /*#__PURE__*/_jsx(CompactSingleLineSkeleton, {}),
  ErrorComponent: AsyncComponentErrorHandler('compact-card-create-source')
});
export default CompactCreateSourceEventAsync;